// config
export const RECEIVE_CONFIG_SITE = 'RECEIVE_CONFIG_SITE';

// content
export const RECEIVE_TEXT_CONTENT = 'RECEIVE_TEXT_CONTENT';

// destination
export const SET_DESTINATION_URGENCY_MESSAGE = 'SET_DESTINATION_URGENCY_MESSAGE';
export const SET_DESTINATION_INFOGRAPHIC = 'SET_DESTINATION_INFOGRAPHIC';
export const SET_UNIT_REVIEWS = 'SET_UNIT_REVIEWS';
export const SET_DESTINATION_IMAGES = 'SET_DESTINATION_IMAGES';
export const SET_INFOGRAPHIC_BOXES = 'SET_INFOGRAPHIC_BOXES';
export const SET_DESTINATIONS_DISCOVERY = 'SET_DESTINATIONS_DISCOVERY';
export const SET_AFFINITIES = 'SET_AFFINITIES';

// listings
export const LOADING_LISTINGS = 'LOADING_LISTINGS';
export const FAILED_LISTINGS = 'FAILED_LISTINGS';
export const SET_LISTINGS = 'SET_LISTINGS';
export const SET_LISTING_ADDITIONAL_CONTENT = 'SET_LISTING_ADDITIONAL_CONTENT';

// destinations listings
export const LOADING_DESTINATIONS_LISTINGS = 'LOADING_DESTINATIONS_LISTINGS';
export const FAILED_DESTINATIONS_LISTINGS = 'FAILED_DESTINATIONS_LISTINGS';
export const SET_DESTINATIONS_LISTINGS = 'SET_DESTINATIONS_LISTINGS';

// i18n
export const RECEIVE_LOCALE = 'RECEIVE_LOCALE';

// search
export const RECEIVE_SERP_URL_DOMAIN = 'RECEIVE_SERP_URL_DOMAIN';
export const RECEIVE_REFINEMENTS = 'RECEIVE_REFINEMENTS';
export const RECEIVE_KEYWORDS = 'RECEIVE_KEYWORDS';
export const RECEIVE_ARRIVAL_DATE = 'RECEIVE_ARRIVAL_DATE';
export const RECEIVE_DEPARTURE_DATE = 'RECEIVE_DEPARTURE_DATE';
export const REDIRECT = 'REDIRECT';
export const HIDE_DATES_POPUP = 'HIDE_DATES_POPUP';
export const SHOW_DATES_POPUP = 'SHOW_DATES_POPUP';
export const UPDATE_SEARCH = 'UPDATE_SEARCH';

// great places
export const HIGHLIGHT_IN_MAP = 'HIGHLIGHT_IN_MAP';
export const CLEAR_MAP_HIGHLIGHT = 'CLEAR_MAP_HIGHLIGHT';
export const NAVIGATE_CAROUSEL = 'NAVIGATE_CAROUSEL';
export const CLEAR_CAROUSEL_FOCUS = 'CLEAR_CAROUSEL_FOCUS';
export const HIDE_GOOGLE_MAP = 'HIDE_MAP';

// family friendly
export const SET_FAMILY_FRIENDLY = 'SET_FAMILY_FRIENDLY';
